import apiManager from '../AxiosInstance';

export const updateLicense = (request: any) => {
  return apiManager.patch(`/api/v1/license/${request?.id}`, request);
};
